"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _client = require("@apollo/client");

var _LoadingOutlined = _interopRequireDefault(require("@ant-design/icons/LoadingOutlined"));

var _spin = _interopRequireDefault(require("antd/lib/spin"));

var _Currency = _interopRequireWildcard(require("@meepshop/context/lib/Currency"));

var _cookies = _interopRequireDefault(require("@meepshop/cookies"));

var _filter = _interopRequireDefault(require("@meepshop/utils/lib/filter"));

var _useInitFx = _interopRequireDefault(require("./hooks/useInitFx"));

var _useFormat = _interopRequireDefault(require("./hooks/useFormat"));

var _gqls = require("./gqls");

var _useInitFx2 = require("./gqls/useInitFx");

var _useFormat2 = require("./gqls/useFormat");

var _index = require("./constants/index");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// import
// graphql import
// definition
var _default = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var _data$viewer;

  var children = _ref.children;

  var _useContext = (0, _react.useContext)(_cookies["default"]),
      cookies = _useContext.cookies,
      setCookie = _useContext.setCookie;

  var _useQuery = (0, _client.useQuery)(_gqls.getStoreCurrency),
      loading = _useQuery.loading,
      error = _useQuery.error,
      data = _useQuery.data;

  var prevCookiesCurrencyRef = (0, _react.useRef)(cookies.currency);

  var _useState = (0, _react.useState)(cookies.currency || _Currency.defaultCurrency),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      currency = _useState2[0],
      _setCurrency = _useState2[1];

  var c = (0, _useFormat["default"])(currency, (0, _filter["default"])(_useFormat2.useFormatFragment, (data === null || data === void 0 ? void 0 : (_data$viewer = data.viewer) === null || _data$viewer === void 0 ? void 0 : _data$viewer.store) || null));
  var value = (0, _react.useMemo)(function () {
    var _CURRENCY_SYMBOL;

    return {
      c: c,
      setCurrency: function setCurrency(newCurrency) {
        _setCurrency(newCurrency);

        setCookie('currency', newCurrency);
      },
      currency: currency,
      currencySymbol: (_CURRENCY_SYMBOL = _index.CURRENCY_SYMBOL[currency]) !== null && _CURRENCY_SYMBOL !== void 0 ? _CURRENCY_SYMBOL : 'NT$'
    };
  }, [c, currency, setCookie]);
  (0, _useInitFx["default"])((0, _filter["default"])(_useInitFx2.useInitFxFragment, (data === null || data === void 0 ? void 0 : data.exchangeRateService) || null));
  (0, _react.useEffect)(function () {
    _setCurrency(cookies.currency || _Currency.defaultCurrency);

    prevCookiesCurrencyRef.current = cookies.currency;
  }, [cookies]);
  if (loading || error) return /*#__PURE__*/_react["default"].createElement(_spin["default"], {
    indicator: /*#__PURE__*/_react["default"].createElement(_LoadingOutlined["default"], {
      spin: true
    })
  });
  return /*#__PURE__*/_react["default"].createElement(_Currency["default"].Provider, {
    value: value
  }, children);
});

exports["default"] = _default;